import React from 'react';
import NavigationPanel_QuickSearch from "../../../navigation/components/search/search";
import Navigation_MyAccountBtn from "../../../navigation/buttons/my-account";
import {SkinTheme} from "../../@const";
import Navigation_ButtonUpgrade from "../../../navigation/buttons/upgrade";
import Navigation_ButtonHelp from "../../../navigation/buttons/help";
import Navigation_ButtonSpace from "../../../navigation/buttons/generic-space";

export default function UITopTeams() {

    const showUpgrade   = !gd.company.license.isPaid

    const classes = Classes("ui-top-teams", {
        "theme-dark": gd.skin.layoutTheme === SkinTheme.DARK,
        "theme-light": gd.skin.layoutTheme === SkinTheme.LIGHT
    })

    return (
        <div className={classes}>
            <div className="left">

            </div>

            <div className="center">
                <NavigationPanel_QuickSearch/>
            </div>

            <div className="right flex-row-right-center m-r-10">
                {showUpgrade &&
                    <Navigation_ButtonUpgrade showLabel={false} className="m-r-15"/>
                }

                <Navigation_ButtonSpace space={gd.spaces.aiChat} className="m-r-15" />
                <Navigation_ButtonSpace space={gd.spaces.settings} className="m-r-15" />

                <Navigation_ButtonHelp className="ui5-ico-18 m-r-15"/>
                <Navigation_MyAccountBtn className="m-0 p-r-5"/>
            </div>

        </div>
    );
}
